import { Clipboard } from '@capacitor/clipboard';
import { getPlatform } from './updateManagerRemote';

export const copy2Clipboard = (text: any) => {
  const platform = getPlatform(); // 判断平台
  console.log('copy2Clipboard', navigator.clipboard, platform);
  if (platform === 'browser' && navigator.clipboard) {
    // 浏览器环境
    // clipboard api 复制
    navigator.clipboard.writeText(text);
  } else {
    var textarea = document.createElement('textarea');
    document.body.appendChild(textarea);
    // 隐藏此输入框
    textarea.style.position = 'fixed';
    textarea.style.clip = 'rect(0 0 0 0)';
    textarea.style.top = '10px';
    // 赋值
    textarea.value = text;
    // 选中
    textarea.select();
    // 复制
    document.execCommand('copy', true);
    // 移除输入框
    document.body.removeChild(textarea);
  }
};

export const readClipboard = async () => {
  const platform = getPlatform(); // 判断平台
  console.log('readClipboard', navigator.clipboard, platform);
  if (platform === 'browser' && navigator.clipboard) {
    // 浏览器环境
    try {
      const text = await navigator.clipboard.readText(); // 获取剪贴板内容
      return text; // 返回剪贴板内容
    } catch (error) {
      console.error('Failed to read clipboard in browser:', error);
      return null;
    }
  } else if (platform !== 'browser') {
    // 移动端环境使用 Capacitor 插件
    try {
      const { type, value } = await Clipboard.read();
      console.log(`Got ${type} from clipboard: ${value}`);
      return value; // 返回剪贴板内容
    } catch (error) {
      console.error('Failed to read clipboard in native:', error);
      return null;
    }
  } else {
    console.error('Clipboard API not supported or no access permission.');
    return null;
  }
};
